import React from 'react';
import Image from 'gatsby-image';
import { useStaticQuery, graphql } from 'gatsby';

import SEO from '../components/seo';
import Layout from '../components/layout';
import Contact from '../components/Contact/Contact';
import Subscribe from '../components/Subscribe/Subscribe';
import AfiliateDeudor from '../components/Afiliate/AfiliateDeudor';
import PlazoIcon from '../components/Icon/PlazoIcon';
import TratoIcon from '../components/Icon/TratoIcon';
import RelojIcon from '../components/Icon/RelojIcon';
import TransferenciaIcon from '../components/Icon/TransferenciaIcon';

const DeudoresPage = () => {
  const result = useStaticQuery(
    graphql`
      {
        file(relativePath: { eq: "deudor-banner.png" }) {
          childImageSharp {
            fluid(quality: 80) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `
  );

  return (
    <Layout>
      <SEO title="Deudores" />
      <section className="min-h-screen relative flex items-center pt-0 md:pt-0">
        <div className="w-7/12 min-h-screen justify-center flex flex-col items-center md:mt-0 md:flex-row">
          <div className="py-20 md:max-w-xl md:my-0">
            <h1 className="text-3xl py-4 md:text-5xl font-thin leading-normal text-gray-700">
              Adelanta el pago a tus proveedores{' '}
              <span className="text-red-100">sin desembolsar un peso</span>
            </h1>
            <p className="text-gray-700 text-xl font-thin">
              Obtén una línea de crédito para que Inversionistas fondeen las
              facturas de tus proveedores. Tu pagas a Fondimex en tus plazos
              preestablecidos.
            </p>
          </div>
        </div>
        <div className="w-6/12 hidden absolute right-0 md:block">
          <Image
            className="z-0 h-screen w-full object-contain"
            fluid={result.file.childImageSharp.fluid}
            alt="Deudores Fondimex"
          />
        </div>
      </section>
      <section style={{backgroundColor: '#fff'}} className="relative pt-0 md:pt-0 min-h-screen md:h-screen">
      <div className="max-w-7xl mx-auto flex flex-col justify-center h-full">
        <div className="mb-16 md:mb-0 md:mb-32 text-center">
          <div className="text-center text-red-100 bg-red-300 opacity-80 rounded-full py-1 inline-block px-4 uppercase tracking-wide text-sm">Empresas</div>
          <h2 className="text-gray-700 text-3xl text-center mt-4 md:text-4xl">Grandes beneficios para nuestros clientes</h2>
        </div>
        <div>
          <div className="flex flex-col md:flex-row md:justify-between">
            <div className="w-full flex-col flex items-center mb-16 md:mb-0 md:justify-center md:flex-row md:w-1/4">
              <RelojIcon />
              <strong className="text-gray-700 text-xl block text-center mt-4 md:hidden">Línea de factoraje rápida</strong>
              <span className="text-gray-600 block text-center text-xl md:hidden">Obtén una línea de factoraje de manera simple y rápida con un excelente servicio de atención.</span>
            </div>
            <div className="w-full flex-col flex items-center mb-16 md:mb-0 md:justify-center md:flex-row md:w-1/4">
              <TratoIcon />
              <strong className="text-gray-700 text-xl block md:w-1/4 text-center mt-4 md:hidden">Solución a tus proveedores</strong>
              <span className="text-gray-600 block text-center text-xl md:hidden">Ofrece la mejor solución de liquidez a tus proveedores.</span>
            </div>
            <div className="w-full flex-col flex items-center mb-16 md:mb-0 md:justify-center md:flex-row md:w-1/4">
              <TransferenciaIcon />
              <strong className="text-gray-700 text-xl block md:w-1/4 text-center mt-4 md:hidden">Una única transferencia</strong>
              <span className="text-gray-600 block text-center text-xl md:hidden">Deja de realizar múltiples transferencias y sólo paga a Fondimex.</span>
            </div>
            <div className="w-full flex-col flex items-center mb-16 md:mb-0 md:justify-center md:flex-row md:w-1/4">
              <PlazoIcon />
              <strong className="text-gray-700 text-xl block  md:w-1/4 text-center mt-4 md:hidden">Plazo mayor, sin afectar a terceros</strong>
              <span className="text-gray-600 block text-center text-xl md:hidden">Extiende el plazo de pago sin afectar a tus proveedores.</span>
            </div>
          </div>
          <div className="hidden md:flex md:justify-between">
            <strong className="text-gray-700 text-xl block w-1/4 text-center mt-4">Línea de factoraje rápida</strong>
            <strong className="text-gray-700 text-xl block w-1/4 text-center mt-4">Solución a tus proveedores</strong>
            <strong className="text-gray-700 text-xl block w-1/4 text-center mt-4">Una única transferencia</strong>
            <strong className="text-gray-700 text-xl block w-1/4 text-center mt-4">Plazo mayor, sin afectar a terceros</strong>
          </div>
          <div className="hidden md:flex md:justify-between">
            <span className="text-gray-600 block w-1/4 text-center text-xl">Obtén una línea de factoraje de manera simple y rápida con un excelente servicio de atención.</span>
            <span className="text-gray-600 block w-1/4 text-center text-xl">Ofrece la mejor solución de liquidez a tus proveedores.</span>
            <span className="text-gray-600 block w-1/4 text-center text-xl">Deja de realizar múltiples transferencias y sólo paga a Fondimex.</span>
            <span className="text-gray-600 block w-1/4 text-center text-xl">Extiende el plazo de pago sin afectar a tus proveedores.</span>
          </div>
          </div>
        </div>
      </section>
      <section className="px-4 pb-20 min-h-screen">
        <AfiliateDeudor />
      </section>
      <Contact type="deudor" />
      <Subscribe />
    </Layout>
  );
}

export default DeudoresPage;
